<template>
  <div class="care-renew-detail">
    <div class="card-box">
      <care-card
        size="big"
        class="card"
        :care="care"
      ></care-card>
      <div class="btn">
        <y-button @click="goto(`/care/${$route.params.id}`)">申请服务</y-button>
      </div>
    </div>
    <div class="more-info module">
      <template
        ><!--审核中无服务记录-->
        <div @click="goRecord">服务记录</div>
        <div class="divider"></div>
      </template>
       <!--  <div @click="goStore">
        附近服务门店
        <span class="sub">如需到店享受服务<br />请先联系400-088-9898预约</span>
      </div>-->
      <!--  <div class="divider"></div>-->
      <div v-if="isWechat && wxCardId" @click="addToWechat">添加至微信卡包</div>
      <div v-if="isWechat && wxCardId" class="divider"></div>
      <div @click="goAgreement">查看详细服务条款</div>
    </div>
    <div class="guide module">
      <img src="@/assets/care_guide_1.png" />
      <img src="@/assets/care_guide_2.png" />
      <img src="@/assets/care_guide_3.png" />
      <img src="@/assets/care_guide_4.png" />
    </div>
    <div v-if="showRenew" class="bottom">
      <div class="renew">
        <div class="r-l">
          <span class="title">{{care.maxMonth}}个月</span>
          <span>续费后最长延长服务</span>
        </div>
        <div class="line"></div>
        <div class="r-r">
          <span class="title">{{care.minAvg}}元/月</span>
          <span>一次性续费最低折合</span>
        </div>
      </div>
      <div class="con">
        <y-button class="btn" @click="gotoRenew()">立即续费</y-button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpOpen } from "../../scripts/network";
import { login } from "../../scripts/auth";
const { wechatCardId } = process.env.CONFIG;

export default {
  name: "CareRenewDetail",
  data() {
    return {
      id: "",
      type: "",
      care: null,
      used : true, // 是否有履约(使用过)
      code: "",
      isWechat: this.$store.state.isWechat,
      wxCardId: wechatCardId
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.loadDetail();
    this.hasUsed();
  },
  computed: {
    showRenew() {
      return this.care && this.care.status == 20 && !this.used;
    }
  },
  methods: {
    async loadDetail() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardInfo", {
          type: "post",
          body: { CardSysNo: this.id },
        });

        if (ret.Status) {
          let card = this.careCardResultMapper(ret.Data);
          this.type = ret.Data.ServiceType;
          this.code = ret.Data.ActivationCode;
          this.care = card;
        } else {
          this.$toast(ret.Message || "加载失败");
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    careCardResultMapper(data) {
      let card = {
        id: data.SysNo,
        type: data.ServiceType,
        endTime: data.FailureTime && new Date(data.FailureTime + "+08:00"),
        name: data.ServiceTypeName,
        imei: data.IMEICode,
        status: data.CardStatus,
        audit: data.AuditStatus,
        auditFailReason: data.AuditFailReason,
        effectiveDay: data.EffectiveDay,
        img: data.CardLogo,
        canRenew: data.IsSupportRenew == 1 && data.CardStatus == 20, // 当前是否可以续费(卡已激活 && 可续费卡)
        maxMonth: Math.floor((data.RenewalsEffectiveDay / 30))
      };
      card.minAvg = (data.RenewalsAmount / card.maxMonth).toFixed(2);
      return card;
    },
    async hasUsed(){ // 查询是否可以续费
      try {
        const ret = await httpOpen("/WuYouCard/JudgeCardUseState", {
          type: "post",
          body: { CardSysNo: this.id },
        });
        this.used = ret.Status; // STATUS 表示是否已使用
        console.log(ret);
      } catch (e) {
        console.error(e);
      }
    },
    gotoRenew() {
      this.$router.push({
        name: "CareRenewPay",
        params: {
          id: this.care.id,
        },
        query: {
          type: this.care.type,
          name: this.care.name,
          time: this.care.endTime && this.care.endTime.getTime()
        },
      });
    },

    async addToWechat() {
      this.$loading.show("");
      const ret = await this.addWechatCard(this.wxCardId);
      this.$loading.hide();
      if (ret === 401) {
        login(this.$store, this.$router);
      }
    },
    goRecord() {
      this.$router.push({
        name: "CareRecord",
        params: {
          id: this.id,
        },
      });
    },
    goStore() {
      this.goto(process.env.CONFIG.storeAddress);
    },
    async goAgreement() {
      this.goto(`/agreement?code=${this.code}`);
    },
  },
};
</script>

<style lang="less" scoped>
.care-renew-detail {
  padding: 16px 16px 150px 16px;
  min-height: 100vh;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  background: #f4f4f4;
  .card-box {
    position: relative;
    margin-bottom: 30px;
    .btn {
      position: absolute;
      width: 100%;
      bottom: -20px;
      display: flex;
      justify-content: center;
      button {
        width: 70%;
      }
    }
  }
  .module {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    transform: rotate(0deg);
  }
  .fill {
    flex: 1 1;
  }
  .more-info {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 16px;
    font-size: 15px;
    color: #000;
    div {
      height: 50px;
      line-height: 50px;
      position: relative;
    }
    .sub {
      position: absolute;
      font-size: 12px;
      line-height: 16px;
      right: 0;
      top: 12px;
      color: #666;
    }
    .divider {
      width: 100%;
      height: 1px;
      background-color: #efefef;
      transform: scaleY(1);
    }
  }
  .bottom {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .renew{
      padding: 20px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .r-l,.r-r{
        display: flex;
        flex-direction: column;
        font-size: 11px;
        text-align: center;
        box-sizing: border-box;
        width: 49%;
        .title{
          font-size: 13px;
          font-weight: 600;
          color: #8D6D41;
        }
      }
      .line{
        width: 1px;
        background-color: #ddd;
      }
    }
    .con {
      padding: 7px 23px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .btn {
        flex: 1 1;
        background: linear-gradient(90deg, #424242 6%, #2f2f2f 96%);
        color: #ffe0a5;
      }
    }
  }

  .guide {
    margin-top: 15px;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
